import { getConfig } from '../utils/config';
import { useDfContext } from '../context/df-context';
import React from 'react';

export function useSearch() {
  const {
    state: { selected, itemFilter },
  } = useDfContext();

  return React.useMemo(() => {
    const filter =
      (itemFilter && itemFilter.language?.length > 0) ||
      (itemFilter && itemFilter?.fileType?.length > 0)
        ? JSON.stringify(itemFilter)
        : null;
    const categoriesQuery = Object.keys(selected || {})
      ?.map(
        (depth) => `c-${encodeURIComponent(depth)}=${encodeURIComponent(selected[Number(depth)])}`,
      )
      .join('&');

    const queryparams = [
      filter ? `filter=${encodeURIComponent(filter)}` : '',
      categoriesQuery ? `${categoriesQuery}` : '',
    ]
      .filter(Boolean)
      .join('&');

    return `${getConfig('resultsPage')}?${queryparams}`;
  }, [selected, itemFilter]);
}
